/* Delivery line: re-check the Christmas deadline in the browser (Oslo date), because a cached page
   can outlive the date. Snippet: snippets/kardima-delivery-line.liquid. */
(function () {
  'use strict';
  function osloToday() {
    try {
      return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Oslo', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
    } catch (e) {
      return new Date().toISOString().slice(0, 10);
    }
  }
  function apply(root) {
    var deadline = root.getAttribute('data-deadline');
    if (!deadline || deadline.length !== 10) return;
    var active = osloToday() <= deadline;
    var xmas = root.querySelector('[data-kdl-xmas]');
    var after = root.querySelector('[data-kdl-after]');
    if (xmas && !active) xmas.hidden = true;
    if (after) after.hidden = active;
  }
  function run() {
    document.querySelectorAll('[data-kardima-delivery]').forEach(apply);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  /* The cart drawer re-renders its footer after an add; re-apply then. */
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();
